import { useState } from "react";
import AppLayout from "@amzn/awsui-components-react/polaris/app-layout";
//import HomepageContent from "./HomepageContent";

import { ServiceNavigation } from "../../../components/navigation";
import "../styles.scss";
import LoginPage from "./Login";
import HomepageContent from "../hub/HomepageContent";

export default function ServiceHomepage() {
  const [navigationOpen, setNavigationOpen] = useState(false);
  return <LoginPage />;
  //return <HomepageContent />;
}
